import React, { useState, FunctionComponent, useEffect, useCallback } from 'react';
import { Presentation } from './presentation';
import { Histories } from '../../../types/personShow';
import { fetchHistoriesCounts, fetchPersonHistories } from '../../../services/personProfiles';

type Props = {
  personId: number;
  isPc: boolean;
};

export const Component: FunctionComponent<Props> = ({
  personId,
  isPc,
}) => {
  const [state, setState] = useState<Histories & {
    isModal: boolean;
    type: 'favorites' | 'entries' | 'scouts';
  }>({
    favorites: [],
    entries: [],
    scouts: [],
    favoritesCounts: 0,
    entriesCounts: 0,
    scoutsCounts: 0,
    isModal: false,
    type: 'favorites',
  });

  const getHistoriesCounts = useCallback(async() => {
    try {
      const response = await fetchHistoriesCounts(personId);
      setState(prev => ({
        ...prev,
        favoritesCounts: response.favoritesCounts | 0,
        entriesCounts: response.entriesCounts  | 0,
        scoutsCounts: response.scoutsCounts | 0,
      }));
    } catch (error) {
      console.log(error);
    }
  }, [personId]);

  const getHistories = useCallback(async() => {
    try {
      const response = await fetchPersonHistories(personId);
      setState(prev => ({
        ...prev,
        favorites: response.favorites,
        entries: response.entries,
        scouts: response.scouts,
      }));
    } catch (error) {
      console.log(error);
    }
  }, [personId]);

  useEffect(() => {
    getHistoriesCounts();
    getHistories();
  }, [personId]);

  const handleOpenModal = useCallback((target: string) => {
    const nextModal = !state.isModal;
    document.body.style.overflow = nextModal ? 'hidden' : 'auto';
    setState((prev) => ({ ...prev, isModal: nextModal, target }));
  }, [state.isModal]);

  return (
    <Presentation
      personId={personId}
      isPc={isPc}
      state={state}
      handleOpenModal={handleOpenModal}
    />
  );
};
